import ChartApi from '../../../pages/industrias/industrias-v2/ChartApi';

const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
            <ChartApi/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainCP;
